<template>
  <div class="layout-wrapper">
    <comp-navbar></comp-navbar>
    <main class="main">
      <section class="layout-content">
        <div class="content">
          <comp-breadcrumb />
          <div class="main-content">
            <router-view v-slot="{ Component }">
              <transition name="fade-transform" mode="out-in">
                <div :key="$route.name || $route.path">
                  <keep-alive :exclude="/Exclude/">
                    <component :is="Component" />
                  </keep-alive>
                </div>
              </transition>
            </router-view>
          </div>
        </div>
        <comp-affix-customer-service />
      </section>
    </main>
  </div>
</template>

<script lang="ts">
export default {
  name: 'LayoutIndex'
}
</script>

<script lang="ts" setup>
import { provide, ref } from 'vue'


const activeIndex = ref('home')

const updateActiveIndex = (index: string) => {
  activeIndex.value = index || ''
}

const pathnameSplits = window.location.pathname.split('/')
if (pathnameSplits.length >= 2) {
  const activeIndexValue = pathnameSplits[1]
  if (activeIndexValue) updateActiveIndex(activeIndexValue)
}

provide('menuProps', {
  activeIndex,
  updateActiveIndex
})
</script>

<style lang="scss" scoped>
@import '@/assets/styles/mixin.scss';
.layout-wrapper {
  width: 100%;
  height: 100%;
  min-width: 1200px;
  .main {
    display: flex;
    width: 100%;
    height: calc(100% - 64px);
  }
}
.layout-content {
  box-sizing: border-box;
  flex: 1;
  width: 0;
  transition: 0.3s;
  height: 100%;
  background: #f7f8fa;

  .content {
    padding: 0 0px 20px 36px;
    height: 100%;
    display: flex;
    flex-direction: column;
    .main-content {
      padding-right: 36px;
      flex: 1;
      overflow-y: scroll;
      @include scrollBar;
    }
  }
}

/* fade-transform */
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.5s;
}

.fade-transform-enter {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
